/* ============
 * Dashboard menu
 * ============
 *
 * This is the dashboard menu component.
 */

import authService from './../../services/auth';
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'account',
      'innerSidebarState',
      'innerSidebar',
      'innerSidebarDisabled',
    ]),

    isVerified() {
      return this.account.verified;
    },

    activeMenu() {
      if (this.$route.name === 'profile.account') {
        return '3';
      }
      return '2';
    },

    routeQuery() {
      return JSON.stringify(this.$route.query) || JSON.stringify({});
    },
  },

  mounted() {
    const checkParentForAnchor = (el) => {
      while (el && el.tagName !== 'A') {
        el = el.parentElement;
      }

      return el && el.tagName === 'A';
    };
    // Code to close the sidebar when clicking on a button inside it.
    this.$refs.sidebar.addEventListener('click', (e) => {
      if (checkParentForAnchor(e.target)) {
        this.toggleSidebar(false);
      }
    });
    document.querySelector('.main').addEventListener('click', (e) => {
      if (this.innerSidebarState && !checkParentForAnchor(e.target)) {
        this.toggleSidebar(false);
      }
    });
  },

  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_INNERSIDEBAR',
    }),

    /**
     * If user has the module.
     */
    hasModule(name) {
      if (this.account.modules !== undefined) {
        const hasModule = this.account.modules.filter(m => (
          m.name === name
        ));
        if (hasModule.length > 0) {
          return true;
        }
      }
      return false;
    },

    /**
     * This method will logout the user.
     */
    logout() {
      authService.logout();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.js